import PageBannerImage from './PageBannerImage'
export default PageBannerImage
